import Link from 'next/link';

import LogoImage from './LogoImage';

const MobileLogo: React.FC = () => {
  return (
    <Link
      href={`${process.env.NEXT_PUBLIC_CANONICAL_HOST}`}
      passHref
    >
      <LogoImage
        src={`${process.env.NEXT_PUBLIC_IMAGES_HOST}/logo-mini.webp`}
        alt={process.env.NEXT_PUBLIC_SITE_NAME}
        width={35}
        height={37}
      />
    </Link>
  );
};

export default MobileLogo;
